import React, { useRef, useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface MiniHistogramProps {
  data: number[];        // full dataset
  highlightIndex: number; // index to highlight (blue bar)
}

const MarketGrowthChart: React.FC<MiniHistogramProps> = ({ data, highlightIndex }) => {
  const chartRef = useRef<HTMLDivElement | null>(null); 
  const [chartWidth, setChartWidth] = useState<number>(600);  // Default width
  const [chartHeight, setChartHeight] = useState<number>(250); // Default height
  const series = [
    {
      name: "Histogram",
      data: data
    }
  ];

  const options: ApexOptions = {
    chart: {
      type: "bar",
      sparkline: { enabled: true }, // removes all padding/axes
    },
    plotOptions: {
      bar: {
        borderRadius: 3,
        columnWidth: "60%",
        distributed: true, // allows individual bar colors
      },
    },
    colors: data.map((_, i) =>
      i === highlightIndex ? "#2979FF" : "#D3D3D3"
    ),
    tooltip: {
      enabled: false,
    },
    dataLabels: { enabled: false },
    grid: { show: false },
  };

  useEffect(() => {
    const updateDimensions = () => {
      if (chartRef.current) {
        setChartWidth(chartRef.current.offsetWidth); // Set width based on container size
        setChartHeight(chartRef.current.offsetHeight); // Set height based on container size
      }
    };

    // Update dimensions on resize
    window.addEventListener("resize", updateDimensions);

    // Set initial dimensions
    updateDimensions();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  return  <div ref={chartRef} style={{ width: "74%", height: "60px" }}>
            <Chart
              options={options}
              series={series}
              type="bar"
              width={chartWidth}
              height={chartHeight}
            />
          </div>;
  // <Chart options={options} series={series} type="bar" height={60} />;
};

export default MarketGrowthChart;
